import image1 from '../../../assets/images/StudentSlides/CharterDay_20170908_4866.jpg'
import image2 from '../../../assets/images/StudentSlides/202_Admissions.jpg'
import image3 from '../../../assets/images/StudentSlides/Autumn Campus-20181102060-JO.jpg'
import image4 from '../../../assets/images/StudentSlides/Color-Rush-Run-20181028079-HS.jpg'
import image5 from '../../../assets/images/StudentSlides/Pre-Orientation-Grazery-20180827028-SS-.jpg'
import image6 from '../../../assets/images/StudentSlides/Pre-Orientation-Mini-Golf-20180827-8509.jpg'
import image7 from '../../../assets/images/StudentSlides/Spring_Campus_Outdoor_Classrooms_20180503167_JO.jpg'
import image8 from '../../../assets/images/StudentSlides/Aoki_Concert20161203_DH_012.jpg'
import image9 from '../../../assets/images/StudentSlides/Bruges_20160818_4434.jpg'
import image10 from '../../../assets/images/StudentSlides/PreOrientation_Kayak20170822_JO002.jpg'
import image11 from '../../../assets/images/StudentSlides/SquashInaugural_20141115_5481.jpg'
import image12 from '../../../assets/images/StudentSlides/Students-in-fall.jpg'

const programs = [
  {img:image12, alt:"Students on campus during fall"},
  {img:image1, alt:"Students at Charter Day"},
  {img:image2, alt:"Students at sporting event"},
  {img:image3, alt:"Student playing guitar"},
  {img:image4, alt:"Students participating in color rush run"},
  {img:image5, alt:"Students eating at The Grazery"},
  {img:image6, alt:"Students playing Mini Golf"},
  {img:image7, alt:"Students learning in outdoor classroom"},
  {img:image8, alt:"Students at a Steve Aoki Concert"},
  {img:image9, alt:"Students eating at The Bruges"},
  {img:image10, alt:"Students kayaking"},
  {img:image11, alt:"Students playing squash"},



];

export default programs;
